export class AppError {

    constructor(public origionalError?: any) {}
}
